<template>
  <button
    :disabled="!currentPermission?.retrieve"
    class="btn disabled-btn mb-2 mt-3 bg-cdp-yellow-400 text-cdp-white hover:bg-cdp-yellow-500"
    @click="openModal(props.type)"
  >
    {{ typeMap[props.type] }}
  </button>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { permissionStore } from '@/stores/permission.js';
import { assetStore } from '@/stores/asset.js';
import { toRaw, computed, onBeforeMount, defineComponent } from 'vue';

export default defineComponent({
  name: 'GeneralAsset',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const storeAsset = assetStore();

    const storePermission = permissionStore();
    const { permission } = storeToRefs(storePermission);
    const {
      setType,
      toggleModal,
      getReferrerInfo,
      setEmailKeywords,
      setSmsKeywords,
      setUuid,
      create
    } = storeAsset;

    const typeMap = {
      filtration: t('asset.edit_filtration'),
      edm: t('asset.edit_edm'),
      sms: t('asset.edit_sms')
    };

    const currentPermission = computed(() => {
      return toRaw(permission.value)['campaign_asset'];
    });

    onBeforeMount(async () => {
      if (currentPermission.value?.retrieve) {
        const referrerInfo = await getReferrerInfo();
        if (referrerInfo) {
          if (referrerInfo.type === 'edm') {
            setEmailKeywords(referrerInfo.emailContentKeywords);
          } else if (referrerInfo.type === 'sms') {
            setSmsKeywords(referrerInfo.smsKeywords);
          }
        }
      }
    });

    async function openModal(type) {
      let uuid = null;
      if (!props.modelValue) {
        uuid = await create(type);
      } else {
        uuid = props.modelValue;
      }

      setUuid(uuid);
      setType(type);
      toggleModal(true);
      emit('update:modelValue', uuid);
    }

    return {
      props,
      toggleModal,
      typeMap,
      openModal,
      currentPermission
    };
  }
});
</script>